import { ENV } from "@wb/env/env";
import { isPreview } from "@wb/env/isPreview";
import { isServer } from "@wb/env/isServer";
import { isStage } from "@wb/env/isStage";
import { env } from "std-env";

export const isProd = (): boolean => {
  if (isStage() || isPreview()) {
    return false;
  }

  if (isServer()) {
    return (
      env.VERCEL_TARGET_ENV === ENV.PROD ||
      env.TARGET_ENV === ENV.PROD ||
      env.NODE_ENV === ENV.PROD ||
      env.MODE === ENV.PROD
    );
  }

  return (
    env.NEXT_PUBLIC_VERCEL_TARGET_ENV === ENV.PROD ||
    env.NODE_ENV === ENV.PROD ||
    process.env.NODE_ENV === ENV.PROD
  );
};
